import { ReportSlice } from './reducer';

export const storesReportSelector = (state: ReportSlice) => {
    return state.adminReport.stores;
};

export const reportItemSelector = (state: ReportSlice) => {
    return state.adminReport.selectedStore;
};
